export { default } from "./NewsArticleDate";
